/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_EmptyInputs */

const en_us2_board_empty = /** @type {(inputs: Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing published yet. Be the first to send a tip.`)
};

const pt_br2_board_empty = /** @type {(inputs: Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada publicado ainda. Seja a primeira pessoa a mandar uma dica.`)
};

const pt_pt2_board_empty = /** @type {(inputs: Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada publicado ainda. Seja a primeira pessoa a mandar uma dica.`)
};

/** @type {(inputs: Board_EmptyInputs) => LocalizedString} */
const es_419_board_empty = en_us2_board_empty;

/** @type {(inputs: Board_EmptyInputs) => LocalizedString} */
const fr_fr2_board_empty = en_us2_board_empty;

/** @type {(inputs: Board_EmptyInputs) => LocalizedString} */
const de_de2_board_empty = en_us2_board_empty;

/** @type {(inputs: Board_EmptyInputs) => LocalizedString} */
const it_it2_board_empty = en_us2_board_empty;

/**
* | output |
* | --- |
* | "Nothing published yet. Be the first to send a tip." |
*
* @param {Board_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_empty = /** @type {((inputs?: Board_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_empty(inputs)
	if (locale === "es-419") return es_419_board_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_board_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_board_empty(inputs)
	if (locale === "de-DE") return de_de2_board_empty(inputs)
	if (locale === "it-IT") return it_it2_board_empty(inputs)
	return en_us2_board_empty(inputs)
});
export { board_empty as "board.empty" }